import React from 'react';

const ConfirmModal = ({
  title,
  message,
  onCancel,
  onConfirm,
}: {
  title: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
}) => (
  <div className='fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50'>
    <div className='bg-white p-6 rounded shadow-md w-80'>
      <h2 className='text-lg font-bold mb-2'>{title}</h2>
      <p className='text-sm mb-4'>{message}</p>
      <div className='flex justify-end gap-2'>
        <button onClick={onCancel} className='px-4 py-1 bg-gray-300 rounded'>
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className='px-4 py-1 bg-red-600 text-white rounded'
        >
          Delete
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
